import { Button, Col, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import axios from "axios";
import { useRouter } from "next/router";
import useWindowSize from "@/hooks/useWindowSize";
import BlogCard from "./BlogCard";

interface ResourceProps {
  slug?: string;

  categories?: any[];
}
const ResourceBlogs = ({ slug, categories }: ResourceProps) => {
  const router = useRouter();
  const [blog, setBlog] = useState<any>([]);
  const [width] = useWindowSize();

  useEffect(() => {
    loadBlog();
  }, [slug]);

  useEffect(() => {
    const handleRouteChange = () => {
      window.scrollTo(0, 0); // Scrolls to the top of the page after navigation
    };

    router.events.on("routeChangeComplete", handleRouteChange);

    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, []);
  const loadBlog = async () => {
    console.log(categories);
    let filterQuery = "";
    categories?.map((category: any, index: number) => {
      filterQuery += `&filters[Categories][slug][$in][${index}]=${category?.attributes?.Slug}`;
    });
    await axios
      .get(
        `${process.env.NEXT_PUBLIC_STRAPI_API_URL
        }/api/posts?populate=*&sort[5]=Date:desc&pagination[pageSize]=4${categories?.length ? filterQuery : ""
        }`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${process.env.NEXT_PUBLIC_STRAPI_API_TOKEN}`,
          },
        }
      )
      .then((res) => {
        if (res?.data?.data?.length >= 4) setBlog(res?.data?.data);
        else loadMoreBlog(res?.data?.data);
      });
  };
  const loadMoreBlog = async (data: []) => {
    await axios
      .get(
        `${process.env.NEXT_PUBLIC_STRAPI_API_URL
        }/api/posts?populate=*&sort[5]=Date:desc&pagination[pageSize]=${4 - data.length
        }`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${process.env.NEXT_PUBLIC_STRAPI_API_TOKEN}`,
          },
        }
      )
      .then((res) => {
        // const updatedList: any = [...data, ...res?.data?.data];
        // if (updatedList?.length >= 5) {
        setBlog([...data, ...res?.data?.data]);
        // } else {
        //   loadMoreCaseStudy(updatedList);
        // }
      });
  };

  return blog?.length > 0 ? (
    <div className="related-blog bg-white pt-case">
      <div className="">
        <Row className="gx-5 max-content-width">
          <Col xs={12} className="p-0">
            <h2 className="blog-text case-mb ">Latest Blogs</h2>
          </Col>
          {/* {blog?.map((item: any, index:any) => (
            <Col xs={12}lg={6} key={index} className="p-0">
            
              <BlogCard key={index} blog={item} width={width} classNameMargin={`${
      index === 2 ? 'mb-0' : 'mb-12'
    } ${index === 1 || index === 3 ? 'ml-12' : ''}`} />
              
          </Col>
           
          ))} */}
          <Col xs={12} lg={6} className="p-0">
            <BlogCard
              blog={blog[0]}
              width={width}
              classNameMargin={` mb-12
              `}
            />
            {/* <h2 className='heading case-mb-4'>Resources</h2> */}
          </Col>
          <Col xs={12} lg={6} className="p-0">
            <BlogCard
              blog={blog[1]}
              width={width}
              classNameMargin={`mb-12 ml-12`}
            />
            {/* <h2 className='heading case-mb-4'>Resources</h2> */}
          </Col>
          <Col xs={12} lg={6} className="p-0">
            <BlogCard
              blog={blog[2]}
              width={width}
              classNameMargin={`mb-0
              `}
            />
            {/* <h2 className='heading case-mb-4'>Resources</h2> */}
          </Col>
          <Col xs={12} lg={6} className="p-0">
            <BlogCard
              blog={blog[3]}
              width={width}
              classNameMargin={`${width > 991 ? "mb-12" : "mt-12"} ml-12`}
            />
            {/* <h2 className='heading case-mb-4'>Resources</h2> */}
          </Col>
        </Row>
        <div className="max-content-width">
          <Button
            className=" float-left explore-more-btn "
            onClick={() => {
              router.push("/resources/blog/");
            }}
          >
            View All Blogs
          </Button></div>
      </div>
      {/* <Button className='me-5 float-right case-more-btn' onClick={() => { router.push('/resources/blog/') }}>Explore More Blogs ➝</Button> */}
    </div>
  ) : (
    <></>
  );
};

export default ResourceBlogs;
